module.exports = __webpack_public_path__ + "static/media/home.0b61be3f.svg";